import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IDiscountRepository } from '../../repositories/interfaces/iDiscountRepository';
import { CSRFTokenRequest } from '../../../entity';
import {
    IGiftCardUserResubscribeVerifyReq,
    IGiftCardUserResubscribeVerifyResponse,
} from '../../../entity/interface/iDiscounts';
export interface IGiftCardUserResubscribeVerifyUseCase {
    execute(
        payload: IGiftCardUserResubscribeVerifyReq,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: CSRFTokenRequest
    ): Promise<IGiftCardUserResubscribeVerifyResponse['data']>;
}

export class GiftCardUserResubscribeVerifyUseCase implements IGiftCardUserResubscribeVerifyUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get giftCardUserResubVerify(): IDiscountRepository {
        return container.resolve<IDiscountRepository>(DI.REPOSITORIES.IDiscountRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        payload: IGiftCardUserResubscribeVerifyReq,
        authToken: string,
        authSign: string,
        identityToken: string,
        csrfToken: CSRFTokenRequest
    ): Promise<IGiftCardUserResubscribeVerifyResponse['data']> {
        const response = await this.giftCardUserResubVerify.giftCardUserResubscribeVerify(
            payload,
            authToken,
            authSign,
            identityToken,
            csrfToken
        );
        return response.data;
    }
}
